export default __webpack_public_path__ + "static/media/cargando.58aefef9.gif";